export default "__VITE_ASSET__26f87c72__"